<!-- /上传  -->
<template>
	<div>
		<el-upload :accept="uploadFormat" list-type="picture-card" :on-preview="handlePictureCardPreview" action=""
			:drag="false" :limit="num" :multiple="false" :file-list="imgUrls" :http-request="uploadHttp"
			:before-upload="beforeAvatarUpload" :on-remove="handleRemove" :on-change="onChange">
			<!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
			<i class="el-icon-plus"></i>
			<div class="el-upload__tip" slot="tip">不超过1MB</div>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="" />
		</el-dialog>
		<!-- <div style="margin-top:100px">
    <img :src="imgUrl" alt="测试图片">
    </div> -->
	</div>
</template>

<script>
	// import ossClient from "../../assets/js/aliyun.oss.client";
	import OSS from "ali-oss";
	import {
		GetUploadKey
	} from "../../../assets/js/network/network";
	import BMF from 'browser-md5-file';
	export default {
		name: "upload",
		props: {
			imgUrlArray: Array,
			num: Number,
			index:Number
		},
		data() {
			return {
				fileNameMd5: '',
				fileMd5: '',
				uploadFormat: ".jpg,.png,.psd,.gif,.jpeg",
				dialogImageUrl: "",
				dialogVisible: false,
				imgUrls: [],
				uploadConf: {
					region: "o",
          accessKeyId: "",
          accessKeySecret: "",
					bucket: "",
					file_power: "",
					upload_dir: "",
					// stsToken: null,
				},
				resindex:''
			};
		},
		watch: {
			imgUrlArray(val) {
				console.log(this.imgUrlArray);
				this.getData();
			},
		},
		mounted() {
			this.init();
			console.log(this.imgUrlArray, this.num);
			if(this.index!=undefined){
				this.resindex=this.index;
			}
			if (!!this.imgUrlArray) {
				this.getData();
			}
			// this.getData();
		},
		methods: {
			getData() {
				this.imgUrls = [];
				if (!!this.imgUrlArray) {
					this.imgUrlArray.map((item) => {
						this.imgUrls.push({
							url: item,
						});
					});
				} else {
					this.imgUrls = [];
				}
			},
			handlePictureCardPreview(file) {
				console.log(file);
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			/**
			 * 初始化
			 */
			init() {
				//获取阿里云token  这里是后台返回来的数据
				let data = {
					upload_type: "",
				};
				GetUploadKey(data).then((res) => {
					// console.log(res);
					this.uploadConf.region = res.ret.region;
					this.uploadConf.accessKeyId = res.ret.accessKeyId;
					this.uploadConf.accessKeySecret = res.ret.accessKeySecret;
					this.uploadConf.bucket = res.ret.bucket;
					this.uploadConf.file_power = res.ret.file_power;
					this.uploadConf.upload_dir = res.ret.upload_dir;

					// this.uploadConf.stsToken = res.ret.stsToken;
				});
			},

			/**
			 * 阿里云OSS上传
			 */
			uploadHttp({
				file
			}) {
				console.log('213213')
				let _this = this;
				_this.fileMd5 = ''
				_this.fileNameMd5 = ''
				const bmf = new BMF();
				bmf.md5(
					file,
					(err, md5) => {
						if (err) {
							this.$message.error("解析失败")
							_this.loading = false
							return
						}
						if (md5) {
							_this.fileMd5 = md5
							_this.fileNameMd5 = _this.fileMd5 + '.' + file.name.substring(file.name.lastIndexOf(".") +
								1);
						}
						if (_this.fileMd5 != '') {
							const fileName = `${_this.uploadConf.upload_dir}/${_this.fileNameMd5}`; //定义唯一的文件名
							var ossClient = (conf) => {
								return new OSS(conf);
							};
							ossClient(_this.uploadConf)
								.put(fileName, file, {
									headers: {
										"x-oss-object-acl": "public-read",
										'Content-Disposition': 'attachment',
									},
									//   ContentType: "image/jpeg",
								})
								.then(({
									res,
									url,
									name
								}) => {
									if (res && res.status == 200) {
										// console.log(`阿里云OSS上传图片成功回调`, res, url, name);
										console.log(file);
										_this.imgUrls.push({
											status: "success",
											uid: file.uid,
											url: url,
											index:_this.resindex
										});
										console.log(_this.imgUrls);
										// consloe.log(fileList)
										// console.log(_this.imgUrls,_this.imgUrl)
										_this.$emit("imgUrlEmit", _this.imgUrls);
									}
								})
								.catch((err) => {
									console.log(`阿里云OSS上传图片失败回调`, err);
								});
						}
					},

				);

			},

			/**
			 * 上传之前
			 */
			beforeAvatarUpload(file) {
        if(file.size == 0){
          this.$message.error('请检查上传文件/封面，文件丢失或已损坏')
          return false
        }
				let typeName = file.name.substring(file.name.lastIndexOf(".")); //获取文件后缀
				if (this.uploadFormat.indexOf(typeName) == -1) {
					this.$message.error(`请上传（${this.uploadFormat}）文件类型`)
					return false
				}



				const isLt1MB = file.size / 1024 / 1024 < 1;
				// console.log(333,isLt1MB)
				if (!isLt1MB) {
					this.$message.error("单张图片大小不能超过 1MB!");
				}
				return isLt1MB;
			},
			onChange(file, fileList) {



			},
			/**
			 * 移除图片
			 */
			handleRemove(file, fileList) {
				console.log(`移除图片回调`, fileList);
				this.imgUrls = fileList;
				this.$emit("imgUrlEmit", this.imgUrls,this.resindex);
			},
		},
	};
</script>

<style>
</style>
